/**
 * useOpenWindow — registry path ile window aç
 * Mini component'lerde kullanılır
 */
import { Suspense, createElement } from 'react'
import { useWindowManager } from '../components/os/WindowManager/WindowManagerContext'
import { WINDOW_REGISTRY } from '../components/os/WindowManager/windowRegistry'

export function useOpenWindow() {
  const { openWindow, windows } = useWindowManager()

  const open = (path: string, title: string, width = 860, height = 580, noPadding = false) => {
    const Component = WINDOW_REGISTRY[path]
    if (!Component) return
    const vw = window.innerWidth
    const vh = window.innerHeight
    const w = Math.min(width, Math.floor(vw * 0.85))
    const h = Math.min(height, Math.floor(vh * 0.80))
    const openCount = windows.length
    const x = Math.max(20, Math.floor((vw - w) / 2) + openCount * 20)
    const y = Math.max(20, Math.floor((vh - h) / 2) + openCount * 20)
    const WrappedComponent = () => createElement(
      Suspense,
      { fallback: createElement('div', { style: { padding: 40, textAlign: 'center', color: 'var(--os-muted)', fontSize: 13 } }, 'Loading...') },
      createElement(Component as any)
    )
    openWindow({ id: path, title, component: WrappedComponent, position: { x, y }, size: { width: w, height: h }, noPadding, _registryPath: path } as any)
  }

  return open
}
